// Cart drawer Access Key (discount code) field. Shopify has no AJAX cart
// endpoint for applying a discount code, only the storefront route
// /discount/{code}?redirect={path}, which sets the code and redirects.
document.addEventListener('submit', function (evt) {
  var form = evt.target.closest('[data-cart-discount-form]');
  if (!form) return;
  evt.preventDefault();

  var input = form.querySelector('input[name="discount"]');
  var code = input && input.value.trim();
  if (!code) return;

  var redirect = form.dataset.redirect || '/cart';
  window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(redirect);
});
